let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5zjWD")).then(() => parcelRequire('2sfBf'));